import VaccineSelect from './VaccineSelect';

export default VaccineSelect;
